module.exports = __webpack_public_path__ + "static/media/ipnosi.b9f0b0dc.svg";